"use strict";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      https://api.resourcewatch.org/v1/query/\n      ", "?\n      sql=", "\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      ", "\n      /dataset/\n      ", "/layer?\n      app=", "\n      &env=", "\n      &page[size]=9999\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      ", "\n      /widget/\n      ", "?\n      ", "\n      &env=", "\n      &language=", "\n      &includes=", "\n      &page[size]=999\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      ", "/fields/\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      ", "\n      /dataset/\n      ", "?\n      application=", "\n      &env=", "\n      &language=", "\n      &includes=", "\n      &page[size]=999\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var shared_1 = require("@widget-editor/shared");

var core_1 = require("@widget-editor/core");

var config_1 = __importDefault(require("./helpers/config"));

var RwAdapter =
/*#__PURE__*/
function () {
  function RwAdapter() {
    _classCallCheck(this, RwAdapter);

    this.endpoint = "https://api.resourcewatch.org/v1";
    this.dataEndpoint = "https://api.resourcewatch.org/v1/query";
    this.config = null;
    this.datasetService = null;
    this.widgetService = null;
    this.datasetId = null;
    this.tableName = null;
    this.AUTH_TOKEN = null;
    this.SQL_STRING = null;
    this.applications = ["rw"];
    this.env = "production";
    this.locale = "en";
    this.requestHandler = null;
    this.requestQue = [];
    this.isAborting = false;
    var asConfig = {
      applications: this.applications,
      env: this.env,
      locale: this.locale
    };
    this.requestHandler = axios_1["default"].create();
    this.config = config_1["default"](asConfig);
    this.datasetService = new core_1.DatasetService(this);
    this.widgetService = new core_1.WidgetService(this);
  }

  _createClass(RwAdapter, [{
    key: "extendProperties",
    value: function extendProperties(props) {
      var _this = this;

      Object.keys(props).forEach(function (prop) {
        if (_this.hasOwnProperty(prop)) {
          _this[prop] = props[prop];
        } else {
          throw new Error("Adapter modifier, error ".concat(prop, " does not exsist on adapter"));
        }
      });
      var asConfig = {
        applications: this.applications,
        env: this.env,
        locale: this.locale
      };
      this.config = config_1["default"](asConfig);
    }
  }, {
    key: "payload",
    value: function payload() {
      return {
        applications: this.applications,
        env: this.env
      };
    }
  }, {
    key: "setDatasetId",
    value: function setDatasetId(datasetId) {
      if (!datasetId) {
        console.error("Error: datasetId is required");
      }

      this.datasetId = datasetId;
    }
  }, {
    key: "setTableName",
    value: function setTableName(tableName) {
      if (!tableName) {
        console.error("Error: datasetId is required");
      }

      this.tableName = tableName;
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'rw-adapter';
    }
  }, {
    key: "getDataset",
    value: function getDataset() {
      var _a;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this$config$getConfi, applications, env, locale, includes, url, _ref, dataset, serializeDataset;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$config$getConfi = this.config.getConfig(), applications = _this$config$getConfi.applications, env = _this$config$getConfi.env, locale = _this$config$getConfi.locale;
                includes = "metadata,vocabulary,layer";
                url = shared_1.tags.oneLineTrim(_templateObject(), this.endpoint, this.datasetId, applications.join(","), env, locale, includes);
                _context.next = 5;
                return this.datasetService.fetchData(url);

              case 5:
                _ref = _context.sent;
                dataset = _ref.data;

                if (dataset) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", {});

              case 9:
                this.tableName = ((_a = dataset === null || dataset === void 0 ? void 0 : dataset.attributes) === null || _a === void 0 ? void 0 : _a.tableName) || null;
                serializeDataset = Object.assign(Object.assign({}, dataset), {
                  attributes: Object.assign({}, dataset === null || dataset === void 0 ? void 0 : dataset.attributes)
                });
                return _context.abrupt("return", serializeDataset);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getFields",
    value: function getFields() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var url, _ref2, fields;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = shared_1.tags.oneLineTrim(_templateObject2(), this.endpoint, this.datasetId);
                _context2.next = 3;
                return this.datasetService.fetchData(url);

              case 3:
                _ref2 = _context2.sent;
                fields = _ref2.fields;
                return _context2.abrupt("return", fields);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "handleDefaultWidgetConf",
    value: function handleDefaultWidgetConf(dataset) {
      return {
        paramsConfig: {
          visualizationType: "chart",
          limit: 50,
          orderBy: null,
          aggregateFunction: null,
          chartType: "bar",
          filters: [],
          areaIntersection: null,
          band: null,
          layer: null,
          value: {
            tableName: this.tableName,
            datasetID: dataset.id
          },
          category: {
            tableName: this.tableName,
            datasetID: dataset.id
          }
        }
      };
    }
  }, {
    key: "abortRequests",
    value: function abortRequests() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isAborting = true;
                this.requestQue.forEach(function (item) {
                  item.cancel();
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "prepareRequest",
    value: function prepareRequest(url) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var self, cancelToken, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = this;

                if (!this.isAborting) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", null);

              case 3:
                cancelToken = new axios_1["default"].CancelToken(function executor(source) {
                  self.requestQue.push({
                    id: url,
                    cancel: source
                  });
                });
                _context4.next = 6;
                return this.requestHandler.get(url, {
                  cancelToken: cancelToken
                });

              case 6:
                response = _context4.sent;
                this.requestQue = this.requestQue.filter(function (q) {
                  return q.id !== url;
                });
                return _context4.abrupt("return", response);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getWidget",
    value: function getWidget(dataset, widgetId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var _this$config$getConfi2, applications, env, locale, includes, url, _ref3, widget;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$config$getConfi2 = this.config.getConfig(), applications = _this$config$getConfi2.applications, env = _this$config$getConfi2.env, locale = _this$config$getConfi2.locale;
                includes = "metadata";

                if (widgetId) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", null);

              case 4:
                url = shared_1.tags.oneLineTrim(_templateObject3(), this.endpoint, widgetId, applications.join(","), env, locale, includes);
                _context5.next = 7;
                return this.widgetService.fetchWidget(url);

              case 7:
                _ref3 = _context5.sent;
                widget = _ref3.data;
                return _context5.abrupt("return", widget);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getLayers",
    value: function getLayers() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6() {
        var _this$config$getConfi3, applications, env, url, _ref4, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this$config$getConfi3 = this.config.getConfig(), applications = _this$config$getConfi3.applications, env = _this$config$getConfi3.env;
                url = shared_1.tags.oneLineTrim(_templateObject4(), this.endpoint, this.datasetId, applications.join(","), env);
                _context6.next = 4;
                return this.datasetService.fetchData(url);

              case 4:
                _ref4 = _context6.sent;
                data = _ref4.data;
                return _context6.abrupt("return", data);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getDataUrl",
    value: function getDataUrl() {
      return shared_1.tags.oneLineTrim(_templateObject5(), this.datasetId, this.SQL_STRING);
    }
  }, {
    key: "requestData",
    value: function requestData(store) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7() {
        var adapterInstance, filtersService, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                adapterInstance = this;
                filtersService = new core_1.FiltersService(store, adapterInstance);
                this.SQL_STRING = filtersService.getQuery();
                _context7.next = 5;
                return this.prepareRequest(this.getDataUrl());

              case 5:
                response = _context7.sent;
                return _context7.abrupt("return", response.data);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getSerializedScheme",
    value: function getSerializedScheme(scheme) {
      return Object.assign(Object.assign({}, core_1.getDefaultTheme()), {
        name: scheme.name,
        range: Object.assign({}, core_1.getDefaultTheme().range, {
          category20: scheme.category
        }),
        mark: Object.assign({}, core_1.getDefaultTheme().mark, {
          fill: scheme.mainColor
        }),
        symbol: Object.assign({}, core_1.getDefaultTheme().symbol, {
          fill: scheme.mainColor
        }),
        rect: Object.assign({}, core_1.getDefaultTheme().rect, {
          fill: scheme.mainColor
        }),
        line: Object.assign({}, core_1.getDefaultTheme().line, {
          stroke: scheme.mainColor
        })
      });
    }
  }, {
    key: "getDeserializedScheme",
    value: function getDeserializedScheme(config) {
      var _a, _b;

      if (!((_a = config === null || config === void 0 ? void 0 : config.range) === null || _a === void 0 ? void 0 : _a.category20) || config.range.category20.length === 0) {
        return null;
      }

      return {
        name: (_b = config.name) !== null && _b !== void 0 ? _b : 'user-custom',
        mainColor: config.range.category20[0],
        category: config.range.category20
      };
    }
  }]);

  return RwAdapter;
}();

exports["default"] = RwAdapter;